export const isUnauthorizedResponse = (error: any) =>
  error?.response?.status === 401;

const getRequestUrl = (error: any) =>
  error?.config?.url || error?.response?.config?.url || "";

const hasStoredAuthSession = () => {
  if (typeof window === "undefined") return false;

  try {
    const authDetails = window.localStorage.getItem("authDetails");
    if (!authDetails) return false;

    const parsed = JSON.parse(authDetails);
    return Boolean(parsed?.token);
  } catch (_error) {
    return false;
  }
};

export const shouldLogoutForUnauthorizedResponse = (error: any) => {
  if (!isUnauthorizedResponse(error)) return false;

  const requestUrl = getRequestUrl(error);
  const isSessionProbe =
    typeof requestUrl === "string" && requestUrl.includes("/users/v1/auths/me");

  return isSessionProbe && hasStoredAuthSession();
};
